<template>
  <div class="db-card-content db-card-content-addon">
    <!-- Title -->
    <h3 class="db-card-title db-title-4">
      <slot name="title" />
    </h3>
    <!-- Description -->
    <p class="db-card-description">
      <slot name="description" />
    </p>
    <!-- Quantity -->
    <div class="db-input-row">
      <DbInput
        v-model="computedQuantity"
        :inputAttrs="{
          pattern: '[0-9]*',
          inputmode: 'numeric',
          type: 'number',
          min: '0',
          max: maxQuantity,
          disabled: disabled,
        }"
      >
        {{ $t('Quantity') }}
      </DbInput>
    </div>
    <!-- Rate -->
    <div class="db-card-rate db-text-right">
      <slot name="rate" />
    </div>

    <div class="db-card-actions">
      <button
        type="button"
        class="db-button-primary db-button-large db-item-start db-card-button-select"
        :class="{ 'db-selected': inCart }"
        :title="$t('Add to cart')"
        :aria-disabled="inCart || +quantity <= 0 ? 'true' : undefined"
        v-on:click="inCart || +quantity <= 0 ? null : $emit('add-to-cart', quantity)"
      >
        <IconDbCartAdded
          v-if="inCart"
          width="28"
          height="28"
        />
        <IconDbCartAdd
          v-else
          width="28"
          height="28"
        />
      </button>
      <button
        v-if="inCart"
        type="button"
        class="db-button-ghost-red db-button-large db-button-square db-card-button-delete"
        :title="$t('Delete')"
        v-on:click="$emit('delete')"
      >
        <IconDbDelete
          width="20"
          height="20"
        />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    /* Is addon added: blocks field et show delete button */
    isInCart: boolean
    /* Max limit of input field */
    maxQuantity?: string | number | undefined
    disabled: boolean
    defaultQuantity: number | undefined
  }>(),
  {
    isInCart: false,
    maxQuantity: undefined,
    disabled: false,
    defaultQuantity: 0,
  },
)

const emit = defineEmits<{
  /* Click on add button */
  (e: 'add-to-cart', quantity: number): void
  (e: 'update-cart', quantity: number): void
  /* Click on delete button */
  (e: 'delete'): void
}>()

const inCart = computed(() => {
  return props.isInCart
})

const quantity = ref(props.defaultQuantity)

watch(
  () => props.defaultQuantity,
  (newValue) => {
    quantity.value = newValue
  },
)

const computedQuantity = computed({
  get() {
    return String(quantity.value)
  },
  set(newVal) {
    quantity.value = Number(newVal)
    emit('update-cart', quantity.value)
  },
})
</script>

<style>
@import '@/assets/styles/components/cards/_addon.css';
</style>
